<div class="row">
  <div class="col-md-5">
    <app-melody-list></app-melody-list>
  </div>
  <div class="col-md-7">
    <div class="sticky-chart">
      <app-melody-chart> </app-melody-chart>
    </div>
  </div>
</div>
